class CustomSelect extends HTMLElement {
  static get observedAttributes() {
    return ["selected"];
  }

  constructor() {
    super();

    this.referenceElement = document.getElementById(this.dataset.referenceId);
    this.currentLabel = this.querySelector("[ custom-select-current]");
    this.mainTrigger = this.querySelector("[custom-select-trigger]");
  }

  connectedCallback() {
    this.init();
  }

  disconectedCallback() {
    // this.removeEventListener('wtSelectChange');
  }

  attributeChangedCallback(name, oldValue, newValue) {
    const onChangeEvent = new CustomEvent("wtSelectChange", {
      detail: {
        prevValue: oldValue,
        value: newValue,
      },
    });
    this.dispatchEvent(onChangeEvent);
  }


  getFocusableElements() {
    const focusableElements = Array.from(
      this.querySelectorAll("[role='option']")
    ).filter((el) => !el.hasAttribute("disabled") && el.tabIndex >= 0);
  
    return {
      all: focusableElements,
      first: focusableElements[0],
      last: focusableElements[focusableElements.length - 1],
    };
  }

  
  setSelectedLabel() {
    const selectedLabel = this.querySelector(
      "[custom-select-list] [selected]",
    )?.textContent;

    this.setAttribute("selected-label", selectedLabel);
    this.currentLabel.textContent = selectedLabel;
  }

  getAttrVal(attr, elem) {
    return elem.hasAttribute(attr) ? elem.getAttribute(attr) : null;
  }

  unselectAll() {
    const listItems = this.querySelectorAll("[custom-select-list] li");
    listItems.forEach((item) => item.removeAttribute("selected"));
  }

  onSelect(val, elem) {
    this.unselectAll();
    this.setAttribute("selected", val);
    elem.setAttribute("selected", "");
    this.setSelectedLabel();
    this.updateReferenceValue();
    this.toggleState();
  }

  createOverlay() {
    if (!document.querySelector("[custom-select-overlay]")) {
      const overlay = document.createElement("div");
      overlay.setAttribute("custom-select-overlay", "");
      document.body.appendChild(overlay);
      overlay.addEventListener("click", () => this.toggleState());
    }
  }

  handleClick(e) {
    const clickedElem = e.target;

    if (
      clickedElem.hasAttribute("custom-select-drawer") ||
      clickedElem === this ||
      clickedElem.classList.contains("wt-options__close")
    ) {
      this.toggleState();
    }

    if (this.getAttrVal("value", clickedElem)) {
      this.onSelect(this.getAttrVal("value", e.target), clickedElem);
    }
  }

  handleKeyDown(e) {
    console.log('10000', e.key)
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      this.toggleState();
      this.querySelector("[custom-select-list] [selected]").focus();
    }
  }

  init() {
    this.createOverlay();
    this.mainTrigger.addEventListener("click", () => this.toggleState());

    this.querySelector("[custom-select-list]").addEventListener("keydown", (e) => {
      const isArrowDown = e.key === "ArrowDown" || e.keyCode === 40;
      const isArrowUp = e.key === "ArrowUp" || e.keyCode === 38;
      const isTab = e.key === "Tab" || e.keyCode === 9;

      const { all } = this.getFocusableElements();

      if (e.key === "Escape" || e.keyCode === 27) {
        if (this.hasAttribute("open")) {
          this.toggleState();
          console.log('3000')
        }
        return;
      }

      if (isTab && this.hasAttribute("open")) {
        this.toggleState();
        return;
      }

      if (e.key === "Enter" || e.key === " ") {
        this.toggleState();
        return;
      }

      if (!(isArrowDown || isArrowUp) || !this.hasAttribute("open")) return;

      const currentIndex = all.indexOf(document.activeElement);

      if (isArrowDown) {
        const nextIndex = currentIndex === all.length - 1 ? 0 : currentIndex + 1;
        all[nextIndex].focus();
        e.preventDefault();
      }

      if (isArrowUp) {
        const prevIndex = currentIndex === 0 ? all.length - 1 : currentIndex - 1;
        all[prevIndex].focus();
        e.preventDefault();
      }

    });
    
    this.addEventListener("click", this.handleClick);
    this.addEventListener("keydown", this.handleKeyDown);

    this.setSelectedLabel();
  }

  updateReferenceValue() {
    this.referenceElement.value = this.getAttribute("selected");
    const inputEvent = new Event("input", { bubbles: true, cancelable: true });
    this.referenceElement.dispatchEvent(inputEvent);
  }

  toggleState() {
    const body = document.body;
    const openBodyAttr = "custom-select-opened";
    const header = document.querySelector("header.page-header");
    const liItems = this.querySelectorAll("li");
    const trigger = this.querySelector("[custom-select-trigger]");
    const isOpen = trigger.getAttribute("aria-expanded") === "true";

    trigger.setAttribute("aria-expanded", !isOpen);

    if (this.hasAttribute("open")) {
      this.removeAttribute("open");
      body.removeAttribute(openBodyAttr);
      body.classList.contains("page-header-sticky")
        ? header.classList.remove("hide")
        : "";
      for (const item of liItems) {
        item.setAttribute("tabindex", "-1");
      }
      this.mainTrigger.focus();
    } else {
      this.setAttribute("open", "");
      body.setAttribute(openBodyAttr, "");
      body.classList.contains("page-header-sticky")
        ? header.classList.add("hide")
        : "";
      for (const item of liItems) {
        item.setAttribute("tabindex", "0");
      }
    }
  }
}

customElements.define("custom-select", CustomSelect);
